__turbopack_context__.v({
  "checkbox": "AddTeamDrawer-module-scss-module__iXyh3G__checkbox",
  "content": "AddTeamDrawer-module-scss-module__iXyh3G__content",
  "delimiter": "AddTeamDrawer-module-scss-module__iXyh3G__delimiter",
  "dropzoneIcon": "AddTeamDrawer-module-scss-module__iXyh3G__dropzoneIcon",
  "footer": "AddTeamDrawer-module-scss-module__iXyh3G__footer",
  "header": "AddTeamDrawer-module-scss-module__iXyh3G__header",
  "hidden": "AddTeamDrawer-module-scss-module__iXyh3G__hidden",
  "image": "AddTeamDrawer-module-scss-module__iXyh3G__image",
  "isFund": "AddTeamDrawer-module-scss-module__iXyh3G__isFund",
  "root": "AddTeamDrawer-module-scss-module__iXyh3G__root",
  "subLabel": "AddTeamDrawer-module-scss-module__iXyh3G__subLabel",
  "subheader": "AddTeamDrawer-module-scss-module__iXyh3G__subheader",
  "teamNameSection": "AddTeamDrawer-module-scss-module__iXyh3G__teamNameSection",
});
